import { useState, useEffect } from 'react';
import { useUser } from '@/lib/hooks/useUser';
import { useMetrics } from './useMetrics';
import { MetricsAction, MetricsCategory } from '@/lib/utils/metrics.utils';

export function useCheckUserProfileCompletion() {
  const { user, refetch: userRefetch } = useUser();
  const { trackEvent } = useMetrics();
  const [showUserInfoDialog, setShowUserInfoDialog] = useState(false);

  useEffect(() => {
    if (
      user &&
      (user.city === 'na' ||
        user.ageGroup === 'na' ||
        user.language === 'na' ||
        !user.acceptedPolicies)
    ) {
      setShowUserInfoDialog(true);

      trackEvent({
        category: MetricsCategory.USER_ACTIVITY,
        action: 'ProfileIncomplete',
        label: 'User Info Dialog Shown',
        value: 0,
        dimensions: {
          missingCity: user.city === 'na',
          missingAgeGroup: user.ageGroup === 'na',
          missingLanguage: user.language === 'na',
          missingAcceptedPolicies: !user.acceptedPolicies,
        },
      });
    }
  }, [user, trackEvent]);

  const handleProfileUpdate = () => {
    userRefetch();

    trackEvent({
      category: MetricsCategory.USER_ACTIVITY,
      action: MetricsAction.PROFILE_UPDATE,
      label: 'User Info Updated',
      value: 1,
      dimensions: {
        city: user?.city,
        ageGroup: user?.ageGroup,
        language: user?.language,
        acceptedPolicies: user?.acceptedPolicies,
      },
    });
  };

  return {
    showUserInfoDialog,
    setShowUserInfoDialog,
    handleProfileUpdate,
    user,
  };
}
